import { render, staticRenderFns } from "./LsvaCalendarFilter.vue?vue&type=template&id=a0384dec&scoped=true&"
import script from "./LsvaCalendarFilter.vue?vue&type=script&lang=js&"
export * from "./LsvaCalendarFilter.vue?vue&type=script&lang=js&"
import style0 from "./LsvaCalendarFilter.vue?vue&type=style&index=0&id=a0384dec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0384dec",
  null
  
)

/* custom blocks */
import block0 from "./LsvaCalendarFilter.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports